export const LazyImageComponent = ({ src, alt, ...props }) => (
    <img src={src} alt={alt} {...props} loading="lazy" />
  );
  